import React, { useMemo, useState} from 'react';
import { useStyles } from "./styles";
//import {CreateCampaignData} from "../../types/campaign";
import { Dialog } from '../Dialog';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { Campaign } from "../../types/campaign";
import SmsIcon from "../../assets/campaign/sms.png";
import WhatsAppIcon from "../../assets/campaign/whatsapp.png";
import EmailIcon from "../../assets/campaign/email.png";
import InstagramIcon from "../../assets/campaign/instagram.png";
import FacebookIcon from "../../assets/campaign/facebook.png";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { Button, ButtonProps } from "@mui/material";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import {useToast} from '../../hooks/useToast'

type DialogProfileProps = {
    data: Campaign;
    open: boolean;
    onClose: () => void;
    updateNot: (typeCampaing: any) => any;
};
const GreenButton = styled(Button)<ButtonProps>(({ theme }) => ({
    width: "100%",
    color: "white",
    backgroundColor: "#78BF77",
    "&:hover": {
      filter: "brightness(0.6)",
      backgroundColor: "#78BF77",
    },
  }));
  
  const RedButton = styled(Button)<ButtonProps>(({ theme }) => ({
    width: "100%",
    color: "white",
    backgroundColor: "#B02F2F",
    "&:hover": {
      filter: "brightness(0.6)",
      backgroundColor: "#B02F2F",
    },
  }));

  const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

  const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, .05)"
        : "rgba(0, 0, 0, .03)",
    // flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {
      marginLeft: theme.spacing(1),
    },
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
  }));

  const GridDiv = ({ className = "", style = {}, children }) => (
    <div className={className} style={style}>
      {children}
    </div>
  );

export function NewAudience(props: DialogProfileProps) {
  const [typeCampaing, setTypeCampaing] = useState({typeCampaign: null})
  const styles = useStyles(); 
  const toast = useToast();   
  const { data, open, onClose, updateNot } = props;
  const iconsCampaigns = useMemo(() => {
    return {
      email: EmailIcon,
      sms: SmsIcon,
      sms_v2: SmsIcon,
      whatsapp: WhatsAppIcon,
      instagram: InstagramIcon,
      instagram_carousel: InstagramIcon,
      facebook: FacebookIcon,
      whatsapp_group: WhatsAppIcon,
    };
  }, []);


  const [expanded, setExpanded] = useState<string | false>("panel1");
  const handleChange =
  (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  const GreenButtonFinal = (props: any) => (
    <GreenButton
      onClick={() => {
        //formik.setFieldValue("typeCampaign", 1);
        setTypeCampaing({typeCampaign: 1})
        setExpanded(false);
      }}
      {...props}
    >
      converteu
    </GreenButton>
  );

  const RedButtonFinal = (props: any) => (
    <RedButton
      onClick={() => {
        //formik.setFieldValue("typeCampaign", 2);
        setTypeCampaing({typeCampaign: 2})
        setExpanded(false);
      }}
      {...props}
    >
      não converteu
    </RedButton>
  );

  return (
    <Dialog
        onClose={onClose}
        fullWidth
        maxWidth="md"
        title="Nova audiência"
        open={open}
        //actions={actions}
    >
        <Box>
            <Box sx={{display: 'flex', marginBottom: '50px'}}>
                <Typography sx={{marginRight: '10px'}} className={styles.typograph}>
                    Você está prestes a criar uma <label style={{color: '#4F4F4F' , fontWeight: '700'}}>nova audiência</label> vinculada a
                  </Typography>
                <img style={{height: '22px', width: '22px'}}
                //className={styles.imgIcon}
                src={iconsCampaigns[String(data.tipo_campanha).toLowerCase()]}
                alt="sms-icon"
                />
                <Typography sx={{marginLeft: '5px'}} className={styles.typograph}>{data.nome_campanha}</Typography>
            </Box>

            <Box>
                <Typography sx={{marginBottom:'20px'}} className={styles.typograph}>Escolha o público dessa audiência</Typography>

                <GridDiv className={styles.accordion}>
                    <Accordion
                        expanded={expanded === "panel1"}
                        onChange={handleChange("panel1")}
                    >
                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                        {typeCampaing.typeCampaign === 1 && (
                            <GreenButtonFinal sx={{ mr: "4px" }} />
                        )}
                        {typeCampaing.typeCampaign === 2 && (
                            <RedButtonFinal sx={{ mr: "4px" }} />
                        )}
                        {typeCampaing.typeCampaign === null && (
                            <Typography sx={{ mr: "8px", color: '#696969', fontWeight :'500'}}>Escolher público</Typography>
                        )}
                    </AccordionSummary>
                    <AccordionDetails>
                        <GreenButtonFinal/>
                        <RedButtonFinal sx={{ mt: "16px" }}/>
                    </AccordionDetails>
                    </Accordion>
                </GridDiv>
            </Box>

            <Box sx={{display:'flex', justifyContent:'space-between'}}>
              <Box></Box>
              <Box>
                <Button
                  data-testid="btn-new-remarketing-campaign"
                  variant="contained"
                  onClick={()=>{
                    if(typeCampaing.typeCampaign !== null){
                      if(data.id_lista_prospeccao !== null){
                        updateNot(typeCampaing.typeCampaign)
                      }else{
                        toast.show("Não foi encontrado audiências vinculadas!", {
                          severity: "error",
                        });
                      }
                    }else{
                      toast.show("Selecione o publico desejado!", {
                        severity: "error",
                      });
                    }
                  }}
                  >
                    Salvar
                  </Button>
              </Box>
            </Box>
        </Box>
    </Dialog>
  );
}